import MeetingCard from './MeetingCard';
import NoShowCard from './NoShowCard';
import { RequestCard, ArrivalCard, WaitingCard, ConfirmPresenceCard, HandoffCard } from './stepCards';

// Maps CARD_FOR ids (from transitions.js) to components.
export const CARD_COMPONENTS = {
  RequestCard,
  MeetingCard,
  ArrivalCard,
  WaitingCard,
  ConfirmPresenceCard,
  HandoffCard,
  NoShowCard,
};
